import emailjs from "emailjs-com";

export const sendInviteEmail = async ({ toEmail, inviteLink, inviteCompany, inviteBy, inviteRole }) => {
  if (!toEmail || !inviteLink || !inviteCompany || !inviteBy || !inviteRole) {
    return false;
  }

  try {
    const templateParams = {
      to_email: toEmail,
      invite_link: inviteLink,
      invite_company: inviteCompany,
      invite_by: inviteBy,
      invite_role: inviteRole
    };

    await emailjs.send(
      process.env.REACT_APP_EMAILJS_SERVICE_ID,
      process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
      templateParams,
      process.env.REACT_APP_EMAILJS_PUBLIC_KEY
    );

    return true;
  } catch (error) {
    return false;
  }
};
